import React from 'react';

export default function Information(props) {
    const { name, tagLine, volumeUnit, volumeValue, firstBrewed, description, imageUrl, food } = props;
    return (
        <section>
            <div className="row">
                <div className="col-md-8">
                    <div className="p-3">
                        <h2>{name}</h2>
                        <h3>{tagLine}</h3>
                        <h4 className="font-weight-normal"><small>Volume: {volumeValue} {volumeUnit}</small></h4>
                        <h5 className="font-weight-normal"><small>First Brewed: {firstBrewed}</small></h5>
                        <div className="my-4">
                            <h5>What we say:</h5>
                            <p className="m-0">{description}</p>
                        </div>

                        <h5>Suggested food paring <small>...as per the API:</small></h5>
                        <p>{food[Math.floor(Math.random() * food.length)]}</p>
                        <p className="m-0"><small>If you ask me I would have suggested Pizza, Pizza goes with everything!</small></p>

                    </div>
                </div>
                <div className="col-md-4">
                    {imageUrl && <div className="p-3 d-flex align-items-md-center h-100 justify-content-center justify-content-md-start">
                        <img src={imageUrl} alt={name} className="beerImage" />
                    </div>}

                </div>
            </div>
        </section>
    )
}